import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { RewardItemValidationSchema } from '../schemas/create.schema'
import { unFormatCurrency } from '@/common/utils/unFormatters'

interface UseCreateRewardItemProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreateRewardItem = ({ onSuccess, onError }: UseCreateRewardItemProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createRewardItem'],
    mutationFn: async (form: RewardItemValidationSchema) => {

      const rewardItem = {
        ...form,
        points_to_redeem: form.points_to_redeem ? Number(form.points_to_redeem.replace(/\D/g, '')) :  undefined,
        reference_price: form.reference_price ? unFormatCurrency(form.reference_price) : undefined,
        establishment_company_branch_id:
          form.establishment_company_branch_id ? form.establishment_company_branch_id.value : undefined,
        product_badges_attributes:
          form.product_badges_attributes ? form.product_badges_attributes.map((item) => ({badge_id: item.value})) : undefined,
        pictures_attachments_attributes:
          form.pictures_attachments_attributes?.length ? form.pictures_attachments_attributes.map((item) => ({blob_id: item.id})) : undefined,
      }

      return privateAxios.post('/tmais/products', {product: rewardItem})
    },
    onSuccess,
    onError,
  })
}

export default useCreateRewardItem
